import React, { useMemo } from 'react';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  FormGroup,
  Grid,
} from '@mui/material';

/** Parse "range(0, 60)" -> { min: 0, max: 60 } */
const parseRange = (opt) => {
  if (typeof opt !== 'string') return {};
  const m = opt.match(
    /^range\(\s*(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*\)$/i,
  );
  if (!m) return {};
  const min = Number(m[1]);
  const max = Number(m[2]);
  return Number.isFinite(min) && Number.isFinite(max) ? { min, max } : {};
};

const InitializationFormFields = ({
  sectionState, // current values for this section
  specification, // array of fields from spec (your "initialization" array)
  onSectionSubmit, // (nextSectionObject) => void
}) => {
  // Merge defaults from spec with current section state
  const value = useMemo(() => {
    const out = {};
    for (const field of specification) {
      const k = field.Key;
      out[k] = sectionState?.[k] ?? field.DefaultValue;
    }
    return out;
  }, [specification, sectionState]);

  const updateField = (key, nextVal) => {
    onSectionSubmit({ ...value, [key]: nextVal });
  };

  return (
    <Grid container spacing={2}>
      {specification.map((field) => {
        const { Key, DisplayName, Type, Options, DefaultValue } = field;
        const fieldValue = value[Key];

        if (Type === 'bool') {
          return (
            <Grid item xs={12} sm={12} key={Key}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!fieldValue}
                      onChange={(e) => updateField(Key, e.target.checked)}
                    />
                  }
                  label={DisplayName}
                />
              </FormGroup>
            </Grid>
          );
        }

        if (Type === 'int') {
          const { min, max } = parseRange(Options);
          return (
            <Grid item xs={12} sm={3} key={Key}>
              <TextField
                fullWidth
                variant="filled"
                label={DisplayName}
                type="number"
                value={fieldValue ?? ''} // keep controlled; allow '' while typing
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === '') {
                    updateField(Key, '');
                    return;
                  }
                  const num = Number(raw);
                  updateField(
                    Key,
                    Number.isFinite(num) ? num : (fieldValue ?? ''),
                  );
                }}
                onBlur={(e) => {
                  if (e.target.value === '') {
                    // snap back to default on blur if left empty
                    updateField(Key, DefaultValue);
                  }
                }}
                InputProps={{ disableUnderline: true }}
                inputProps={{
                  ...(min !== undefined ? { min } : {}),
                  ...(max !== undefined ? { max } : {}),
                  step: 1,
                }}
                sx={{
                  '& .MuiFilledInput-root': {
                    borderRadius: 1,
                    overflow: 'hidden',
                  },
                }}
              />
            </Grid>
          );
        }

        return null;
      })}
    </Grid>
  );
};

export default InitializationFormFields;
